import { VideoComponent } from '@abiglobalhealth/go-types'

export const Video = ({ id, src }: Omit<VideoComponent, 'componentType'>) => {
  return (
    <video id={id} className="w-full" controls>
      <source src={src} type="video/mp4" />
      Video not supported
    </video>
  )
}
